import { FC } from "react";
import { StepOption } from "../../../types/wizard";

interface ColorInputProps {
  color?: StepOption | null;
  toggleEdit: () => void;
}

const ColorInput: FC<ColorInputProps> = ({ color, toggleEdit }) => {
  const handleClick = () => {
    if (toggleEdit) {
      toggleEdit();
    }
  };

  const borderColor: boolean = !!(color?.htmlColor && color.htmlColor === "#FFFFFF");

  return (
    <>
      <div
        className="p-2.5 cursor-pointer relative rounded bg-white"
        onClick={handleClick}
        style={{ border: "1px solid #ccc" }}>
        {color && color?.htmlColor ? (
          <div className="flex flex-row items-center gap-2">
            <div
              className="w-8 h-8 rounded"
              style={{
                backgroundColor: color.htmlColor || "",
                border: `${borderColor ? '1px solid #a7acaf' : 'none'}`,
              }}></div>
            <span>{color.name}</span>
            <span
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm underline"
              onClick={handleClick}>
              Edit
            </span>
          </div>
        ) : (
          <>
            <div className="flex flex-row justify-between items-center text-slate-400">
              <span style={{ display: "flex" }}>Select a Color</span>
            </div>
            <span
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm underline"
              onClick={handleClick}>
              Edit
            </span>
          </>
        )}
      </div>
    </>
  );
};

export default ColorInput;
